import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';
import { Typography } from '@/components/Typography';
import { px2rem } from '@/theme';

export const Header = styled(Typography)`
  font-weight: 500;
  line-height: 120%; /* 24px */
  text-transform: uppercase;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${px2rem(20)};
  `}
`;

export const Description = styled(Typography)`
  font-weight: 400;
  line-height: 22px;

  ${({ theme }) => css`
    padding-bottom: ${theme.spacing(2)};
    color: ${theme.colors.secondaryGrey};
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${px2rem(14)};
  `}
`;

export const Gift = styled(Box)<{
  disabled: boolean;
}>`
  text-align: center;
  font-weight: 400;
  line-height: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ disabled, theme }) => css`
    color: ${theme.colors.black};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${px2rem(14)};
    ${disabled &&
    css`
      color: ${theme.colors.secondaryGrey};
    `}
  `}
`;

export const GiftImageWrapper = styled(Box)<{
  $active: boolean;
  disabled: boolean;
}>`
  position: relative;
  outline: 1px solid #ebebeb;
  box-sizing: border-box;
  ${({ $active, disabled, theme }) => css`
    background: ${theme.colors.white};
    ${disabled &&
    css`
      color: ${theme.colors.secondaryGrey};
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        outline: 1px solid #ebebeb;
        background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.5) 0%,
          rgba(255, 255, 255, 0.5) 100%
        );
      }
    `}
    outline: ${$active
      ? `3px solid ${theme.colors.primaryDark}`
      : `1px solid ${theme.colors.secondaryGrey}`};
    margin-bottom: ${theme.spacing(1)};
    height: 95px;
    ${theme.media.md.up} {
      height: 130px;
    }
  `}
`;

export const GiftImage = styled(NextImage)`
  object-fit: contain;
  ${({ theme }) => css`
    height: 95px;
    width: 95px;
    ${theme.media.md.up} {
      height: 130px;
      width: 130px;
    }
  `}
`;

export const GiftDesc = styled(Box)`
  max-width: 93px;
`;

export const Gifts = styled(Flex)`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Section = styled(Flex)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};
  `}
`;
